import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

/**
 * Password field with a show/hide eye toggle. Drop-in replacement for
 * <Input type="password" />: forwards all props to the underlying Input
 * except `type`, which we manage.
 *
 * The toggle button has data-testid="password-toggle" and pushes the
 * input padding right so the icon never overlaps typed characters.
 */
export default function PasswordInput({
  className = "",
  toggleTestId = "password-toggle",
  ...props
}) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input
        {...props}
        type={visible ? "text" : "password"}
        className={`pr-11 ${className}`}
      />
      <button
        type="button"
        data-testid={toggleTestId}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        onClick={() => setVisible((v) => !v)}
        className="absolute inset-y-0 right-0 flex w-11 items-center justify-center text-[var(--aurion-muted)] transition-colors hover:text-[var(--aurion-gold)] focus:text-[var(--aurion-gold)] focus:outline-none"
        tabIndex={0}
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}
